<template>
  <el-card class="container">
    <el-row>
      <el-col :span="12" :offset="12" style="text-align: right; padding-right: 60px">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="getCost"
          size="small"
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-col>
    </el-row>
    <!--el-row class="div-row">
      <el-col>
        <div ref="bizCostChart" style="height:400px"></div>
      </el-col>
    </el-row-->
    <el-row class="div-row">
      <el-col>
        <el-table :data="usageData" border lazy :load="loadDetail" row-key="key"
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}" max-height="800">
          <el-table-column prop="accountType" label="服务商" width="120" fixed></el-table-column>
          <el-table-column prop="accountId" label="账号ID" width="120" fixed></el-table-column>
          <el-table-column prop="business" label="部门" width="100" fixed></el-table-column>
          <el-table-column prop="service" label="服务类型" width="100" fixed></el-table-column>
          <el-table-column prop="dataType" label="数据类型" width="100" fixed></el-table-column>
          <el-table-column prop="total" label="总计" width="100" fixed></el-table-column>
          <el-table-column v-for="date of dates" :key="date" :prop="date" :label="date" width="100">
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </el-card>
</template>
<script>
import moment from 'moment';
import * as echarts from 'echarts';
require('echarts/theme/macarons')
export default {
  data() {
    return {
      dateRange: [],
      usageData: [],
      dates: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  mounted() {
    let m = moment();
    let e = m.subtract(1, 'days').format('YYYY-MM-DD');
    let s = m.subtract(14, 'days').format('YYYY-MM-DD');
    this.dateRange = [s, e];
    this.getCost();
  },
  methods: {
    async getCost() {
      if (this.dateRange.length < 2) {
        this.$notify({
            title: '警告',
            message: '请选择起止日期',
            type: 'warning'
        })
        return;
      }

      let [start, end] = this.dateRange;

      let url = `/ams/service/usage?start=${start}&end=${end}`;
      let rsp = await this.$http.get(url);
      this.usageData = this.parseServiceUsage(start, end, rsp.data.data, true);
      return
    },
    groupBy (xs, key) {
      if (Object.keys(xs).length == 0) {
        return {}
      }

      return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    genDates(start, end) {
      let dates = [];
      start = moment(start);
      end   = moment(end);
      while (start <= end) {
        dates.push(start.format('YYYY-MM-DD'));
        start.subtract(-1, 'days')
      }
      this.dates = dates;
      return dates;
    },
    sum(arr) {
      return parseFloat(arr.reduce((a,b)=>a+b).toFixed(2))
    },
    fillData(start, end, data) {

      let dateRange = this.genDates(start, end);

      Object.keys(data).forEach(k => {
        dateRange.forEach(d => {
          data[k][d] = data[k][d] || 0;

        data[k] = Object.keys(data[k]).sort().reduce(
          (obj, key) => {
            obj[key] = data[k][key];
            return obj;
          },
          {}
        );
        })
      })


      return data;
    },
    parseServiceUsage(start, end, usage, hasChildren) {

      let svrUsage = {};
      let dateRange = this.genDates(start, end);
      let du = {};
      dateRange.forEach(d => du[d] = 0);

      usage.forEach((u) => {
        let k = `${u.account_type}:${u.account_id}:${u.business}:${u.data_type}:${u.service}`;

        svrUsage[k] = svrUsage[k] || JSON.parse(JSON.stringify(du));
        svrUsage[k][u.date] = u.amount;
        svrUsage[k]['accountType'] = hasChildren ? u.account_type: '-';
        svrUsage[k]['accountId'] = hasChildren ? u.account_id: '-';
        svrUsage[k]['business'] = hasChildren ? u.business: '-';
        svrUsage[k]['dataType'] = u.data_type;
        svrUsage[k]['hasChildren'] = hasChildren;
        svrUsage[k]['service'] = u.service;
        svrUsage[k]['key'] = k;
        svrUsage[k]['total'] = svrUsage[k]['total'] || 0;
        svrUsage[k]['total'] += u.amount;
      })

      svrUsage = Object.keys(svrUsage).sort().reduce(
        (obj, key) => {
          svrUsage[key].total = svrUsage[key].total.toFixed(0);
          obj[key] = svrUsage[key];
          return obj;
        },
        {}
      );

      return Object.values(svrUsage);

    },
    async loadDetail(tree, treeNode, resolve) {
    
      let [start, end] = this.dateRange;

      let url = `/ams/service/usage?start=${start}&end=${end}&account_type=${tree.accountType}&account_id=${tree.accountId}&business=${tree.business}`;
      let rsp = await this.$http.get(url);
      let d = this.parseServiceUsage(start, end, rsp.data.data, false);
      d.sort((a, b) => b.total - a.total);
      resolve(d);
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  margin: 20px;
}
.div-row {
  margin-top: 30px;
}
</style>
